import * as types from "./constant";
// import apis from "@/apis";
export default {
    state: {
        locationList: [],
        currentLocation: {}
    },
    actions: {
        async setCurrentLocation({ commit }, currentLocation) {
            commit(types.CURRENT_LOCATION, currentLocation)
        },
        async setLocationList({ commit }, locationList) {
            commit(types.CURRENT_LOCATION, locationList)
        },
    },
    mutations: {
        [types.LOCATION_LIST](state, locationList) {
            state.locationList = locationList
        },
        [types.CURRENT_LOCATION](state, currentLocation) {
            state.currentLocation = currentLocation
        }
    },
    getters: {
        locationList({ locationList }) {
            return locationList
        },
        currentLocation({ currentLocation }) {
            return currentLocation
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/location/index.js